<template>
     <v-container fluid>
         <v-card>
            <v-toolbar>
                <v-icon>cloud_download</v-icon>
                <v-toolbar-title class="font-weight-light">&nbsp;Generar Boletín Siisa</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                    <v-icon v-if="action.esFrecuente">favorite</v-icon>
                    <v-icon v-else>favorite_border</v-icon>
                    </v-btn>
                </template>
                <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
                <span v-else>Agregar a Tareas Frecuentes</span>  
                </v-tooltip>
            </v-toolbar>
            <v-card-text>
                <span class="title" >Filtros</span>
                <v-divider></v-divider>
                <v-row dense>
                    <v-col cols="6" lg="6">
                        <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas" autocomplete="disabled"
                            item-text="nombre" item-value="id" label="Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col> 
                    <!--
                    <v-col cols="6" lg="3">
                        <v-autocomplete v-model="filtro.canalVentaId" :items="listCanalesVenta" autocomplete="disabled"
                            item-text="nombre" item-value="id" label="del Canal de Venta" placeholder="Seleccione uno" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col> -->
                    <!-- <v-col cols="6" lg="3">
                        <v-autocomplete v-model="filtro.productoId" :items="listProductos" autocomplete="disabled"
                            item-text="descripcion" item-value="id" label="del Producto" placeholder="Seleccione uno" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col> -->
                </v-row>
                <v-row dense>
                    <v-col cols="6" lg="6">
                       <v-text-field v-model="filtro.fechaDesde" label="Fecha Desde" type="date" prepend-icon="event"></v-text-field>
                    </v-col>
                    <v-col cols="6" lg="6">
                       <v-text-field v-model="filtro.fechaHasta" label="Fecha Hasta" type="date" prepend-icon="event"></v-text-field>
                    </v-col><!--
                    <v-col cols="6" lg="3">
                        <v-autocomplete v-model="filtro.sucursalId" :items="listSucursales" autocomplete="disabled"
                            item-text="nombre" item-value="id" label="Liquidado en" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col> -->
                </v-row>
                <!--
                <span class="title" >Opciones</span>
                <v-divider></v-divider>
                <v-row dense>
                    <v-col cols="10" lg="6">
                        <v-radio-group v-model="filtro.agrupamiento" :mandatory="true" label="Agrupar por" row>
                            <v-radio value="0">
                                <div slot="label">Producto/Plan</div>
                            </v-radio>
                            <v-radio value="1">
                                <div slot="label">Tipo Cliente/Producto/Plan</div>
                            </v-radio> 
                             <v-radio value="2">
                                <div slot="label"> Vendida</div>
                            </v-radio> 
                            
                        </v-radio-group>
                    </v-col>
                    <v-col cols="6" lg="3">
                        <v-switch v-model="filtro.resumido" label="Resumido"></v-switch>
                    </v-col>            
                    <v-col cols="2" lg="1">
                        <v-text-field v-model="filtro.separador" label="Separador en archivo"></v-text-field>
                    </v-col>                            
                </v-row>
                        -->
            </v-card-text>
            <v-card-actions>
                <v-btn dark  color="green" @click="procesarBase">
                    Descargar Archivo&nbsp;
                    <v-icon >cloud_download</v-icon>                  
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn dark  color="green" @click="procesarReporte">
                    Generar Reporte&nbsp;
                </v-btn>
            </v-card-actions>

         </v-card>

        <app-loading :loading="loading"></app-loading>

     </v-container>
</template>
<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data() {
        return {
            loading: false,
            filtro: {
                    empresaId: 1, 
                    fechaDesde: null, 
                    fechaHasta: null,
                    separador: ';'},
            listEmpresas: [],
        }
    },
    async created() {
      this.loadEmpresas();

      this.filtro.fechaDesde = this.$moment().startOf('month').format('YYYY-MM-DD');
      this.filtro.fechaHasta = this.$moment(new Date()).format('YYYY-MM-DD');
    }, 
    computed: {
        ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
        action: function(){
        return this.getActionFromLink(this.$route.path) 
        },
    },
  methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError","setReporteActivo"]),
    ...mapActions(['setStatusTareaFrecuente']),    
    async loadEmpresas(){
        this.loading = true;
        try{
            var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);

            this.listEmpresas = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    // async loadSucursales(){
    //   this.loading = true;
    //   try{
    //     var result = await http.get('sucursales/list/porusuario?usuarioId='+this.user.id);

    //     this.listSucursales = result.list;

    //     this.listSucursales.unshift({id:0,nombre:'(Todas)'});
    //   }
    //   catch(error){
    //     // Error
    //     this.alertError(error)
    //   }
    //   this.loading = false;
    // },
    // async loadCanalesVenta(){
    //   this.loading = true;
    //   try{
    //     var result = await http.get('canalesventa/habilitadosparausuario?usuarioId='+ this.user.id);

    //     this.listCanalesVenta = result.list;
    //     this.listCanalesVenta.unshift({id:0,nombre:'(Todos)'});
    //   }
    //   catch(error){
    //     // Error
    //     this.alertError(error)
    //   }
    //   this.loading = false;
    // },
    // async loadProductos(){
    //   this.loading = true;
    //   try{
    //     var result = await http.get('productos/');        

    //     this.listProductos = result.list;
    //     this.listProductos.unshift({id:0,descripcion:'(Todos)'});
    //   }
    //   catch(error){
    //     // Error
    //     this.alertError(error)
    //   }
    //   this.loading = false;
    // },
    validar(){
        if(this.filtro.empresaId === 0) 
        {
            this.alertWarning('Debe seleccionar una Empresa.');
            return false;
        }

        if(!this.filtro.fechaDesde ) 
        {
            this.alertWarning('Debe ingresar la Fecha de Cobranza Desde.');
            return false;
        }

        if(!this.filtro.fechaHasta ) 
        {
            this.alertWarning('Debe ingresar la Fecha de Cobranza Hasta.');
            return false;
        }

        return true;
    },
    async procesarReporte(){

        // validaciones
        if(!this.validar()) 
        {
            return;
        }

        var self = this;

        try {
            self.loading = true;
            
            let params = [];
            params.push({
                "EmpresaId": this.filtro.empresaId,
                "FechaDesde": this.filtro.fechaDesde,
                "FechaHasta": this.filtro.fechaHasta,
            } );

                this.setReporteActivo({reporte: 'Boletin Siisa.trdp', params: params})
                window.open('/report-viewer');
            
        } catch (error) {
            // Error
            self.alertError(error)
        }
        self.loading = false
    },
    async procesarBase(){

        // validaciones
        if(!this.validar()) 
        {
            return;
        }

        var self = this;

        try {
            self.loading = true;

            await http.post('filegeneration/boletinsiisa', JSON.stringify( {parametros: this.filtro} ) )
                .then(resp => {
                    console.log(resp);

                    if(resp.error ){
                        self.alertError(resp.error);
                    }
                    else{
                        self.alertSuccess('Se generó correctamente el archivo. Aguarde unos instantese mientras se descarga el archivo...');
                        
                        self.loading = true;
                        self.downloadFile(resp, 'BoletinSiisa.txt');
                        self.loading = false;
                    }

                })
                .catch((e) => {
                    self.alertError(e)
                });
            
        } catch (error) {
            // Error
            self.alertError(error)
        }
        self.loading = false
    },
    async downloadFile(file, renameTo){
        //convierto el string del path a base64 para poder mandarlo
        let base64String = '';
        base64String = btoa(file.fullPath);
        
        http.get('filemanagement/getfilebypath/'+base64String)
        .then(resp => {
            let dataType = '';
            switch(resp.extension)
            {
                case '.doc':
                case '.docx':
                case '.DOC':
                case '.DOCX':
                    dataType = 'data:application/vnd.ms-word';
                    break;
                case '.pdf':
                case '.PDF':
                    dataType = 'data:application/pdf'
            }
            
            //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
            var arrayBuffer = this.base64ToArrayBuffer(resp.file);
            this.saveByteArray(renameTo, arrayBuffer,dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], {type: dataType});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();      
    },
},
  
}
</script>